<app-image-section-head [title]="title" [description]="description" [image]="image"></app-image-section-head>

<app-exception
    [applicantId]="applicantId"
    [selectedVehicle]="selectedVehicle"
    [autType]="autType"
    (goBackEvent)="goBack()"
></app-exception>